import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      console.log('Submitting form data:', formData);
      
      const response = await fetch('https://oeqhfpb4mfhb7gxp34jkqfgbme0hixgp.lambda-url.us-east-1.on.aws/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      
      const responseText = await response.text();
      console.log('Response text:', responseText);

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        console.error('Request failed with status:', response.status);
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      if (error instanceof TypeError && error.message.includes('fetch')) {
        console.error('Network error - possibly CORS or connectivity issue');
      }
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="px-8 py-20 animate-fadeIn">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-6xl font-bold mb-6">Contact Us</h1>
        <p className="text-xl text-brand-text-dark mb-16">
          Have a project in mind or want to learn more about our services? We'd love to hear from you.
        </p>
      </div>

      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-16 items-start">
        {/* Contact Form */}
        <div className="bg-brand-gray p-8 rounded-xl border border-brand-light-gray">
          <h2 className="text-3xl font-bold mb-6">Send us a Message</h2>
          
          {submitStatus === 'success' && (
            <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
              Thank you! Your message has been sent successfully. We'll get back to you soon.
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              Sorry, there was an error sending your message. Please try again or email us directly.
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="name" className="block text-brand-text-dark mb-2">Full Name</label>
              <input 
                type="text" 
                id="name" 
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full bg-brand-light-gray rounded-lg border-2 border-transparent focus:border-brand-primary focus:ring-0 p-3" 
              />
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block text-brand-text-dark mb-2">Email Address</label>
              <input 
                type="email" 
                id="email" 
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full bg-brand-light-gray rounded-lg border-2 border-transparent focus:border-brand-primary focus:ring-0 p-3" 
              />
            </div>
            <div className="mb-6">
              <label htmlFor="message" className="block text-brand-text-dark mb-2">Message</label>
              <textarea 
                id="message" 
                rows={5} 
                value={formData.message}
                onChange={handleInputChange}
                required
                className="w-full bg-brand-light-gray rounded-lg border-2 border-transparent focus:border-brand-primary focus:ring-0 p-3"
              ></textarea>
            </div>
            <button 
              type="submit" 
              disabled={isSubmitting}
              className="w-full bg-brand-primary hover:bg-opacity-80 disabled:bg-gray-400 text-white font-bold py-3 px-6 rounded-lg transition-colors"
            >
              {isSubmitting ? 'Sending...' : 'Submit Inquiry'}
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div className="space-y-8">
          <div>
            <h3 className="text-2xl font-bold text-brand-primary mb-2">Email Us</h3>
            <a href="mailto:contact@dcconsulting.cc" className="text-lg hover:underline">contact@dcconsulting.cc</a>
            <p className="text-brand-text-dark">For all project inquiries and questions.</p>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-brand-primary mb-2">Follow Us</h3>
            <div className="flex space-x-4">
              <button className="hover:text-brand-secondary text-left" onClick={() => window.open('https://linkedin.com/company/dc-consulting', '_blank')}>LinkedIn</button>
              <button className="hover:text-brand-secondary text-left" onClick={() => window.open('https://twitter.com/dcconsulting', '_blank')}>Twitter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 